import { z } from "zod";

export const sectorBoundaryRulesSchema = z.strictObject({
  version: z.literal("sector-boundary-v1"),
  referenceDistance: z.number().finite().positive(),
  hullFractionPerSecond: z.number().finite().positive(),
});
export type SectorBoundaryRules = z.infer<typeof sectorBoundaryRulesSchema>;

export const SECTOR_BOUNDARY_RULES: Readonly<SectorBoundaryRules> = Object.freeze({
  version: "sector-boundary-v1",
  referenceDistance: 1000,
  hullFractionPerSecond: 0.1,
});

export function outsideSectorDistance(point: { x: number; y: number },
  region: { x: number; y: number; width: number; height: number }): number {
  return Math.hypot(
    Math.max(region.x - point.x, 0, point.x - region.x - region.width),
    Math.max(region.y - point.y, 0, point.y - region.y - region.height),
  );
}

export function sectorBoundaryDamage(rules: SectorBoundaryRules, distance: number, maxHp: number): number {
  return Math.max(0, distance) / rules.referenceDistance * rules.hullFractionPerSecond * maxHp;
}
